export const selectCreditCard = state => state.account.card
export const selectCreditCards = state => state.account.cards
